

import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  create_calendar_availability_action,
  delete_calendar_availability_action,
  get_calendar_availability_details_action,
  get_calendar_availability_lists_action,
  get_loggedin_user_meta_data_action,
  update_calendar_availability_action,
} from "../../../../redux/_actions";
import { dIntervalsGenerator } from "../CalendarOnboard/constants";
import { defaultAvailability } from "./constants";
import { useNavigate } from "react-router-dom";
import { showWarningMessage } from "../../../../_uiComponents/ShowMessageSnack";

function useAvailability() {
  const [show, setShow] = useState(false);
  const [availabilityList, setAvailabilityList] = useState({});
  const [availabilityDetail, setAvailabilityDetail] = useState(null);
  const [editTitleActive, setEditTitleActive] = useState(false);
  const [timeIntervals, setTimeIntervals] = useState();
  const [createAvailabilityTitle, setCreateAvailabilityTitle] = useState("");
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [isCreateAvailabilityLoading, setIsCreateAvailabilityLoading] =
    useState(false);
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);

  //for showing interval dropdowns
  const [showStartIntervalDropdown, setShowStartIntervalDropdown] =
    useState(false);
  const [showEndIntervalDropdown, setShowEndIntervalDropdown] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dummyClickRef = useRef(null);

  const { calendarAvailabilityData } = useSelector(
    (state) => state.get_calendar_availability_details_data_reducer
  );
  const { calendarAvailabilityListsData } = useSelector(
    (state) => state.get_calendar_availability_lists_data_reducer
  );

  const { loggedInMetaData } = useSelector(
    (state) => state.get_loggedin_user_meta_data_reducer
  );

  useEffect(() => {
    getUserMeta();
  }, []);

  useEffect(() => {
    if (loggedInMetaData?.data) {
      setUser(loggedInMetaData?.data);
    }
  }, [loggedInMetaData]);

  useEffect(() => {
    const callAllAvailabilityApi = async () => {
      setLoading(true);
      await dispatch(get_calendar_availability_lists_action());
      setLoading(false);
    };

    callAllAvailabilityApi();
  }, []);
  useEffect(() => {
    let arr = dIntervalsGenerator();
    setTimeIntervals(arr);
  }, []);

  useEffect(() => {
    if (calendarAvailabilityListsData?.data) {
      setAvailabilityList(calendarAvailabilityListsData?.data);

      let results =
        calendarAvailabilityListsData?.data &&
        calendarAvailabilityListsData?.data.results;

      if (results.length > 0) {
        let id = results[0].id;
        setAvailabilityDetail(results[0]);
      } else {
        setAvailabilityDetail({});
      }
    }
  }, [calendarAvailabilityListsData]);

  useEffect(() => {
    if (calendarAvailabilityData?.data) {
      setAvailabilityDetail(calendarAvailabilityData?.data);
    }
  }, [calendarAvailabilityData]);

  const getUserMeta = async () => {
    await dispatch(get_loggedin_user_meta_data_action());
  };

  const handleClose = () => {
    setShow(false);
    setCreateAvailabilityTitle("");
  };
  const handleShow = () => setShow(true);

  const onEditTitle = (value) => {
    setEditTitleActive(value);
  };

  const onFormInputChange = (e) => {
    let data = availabilityDetail,
      name = e.target.name,
      value = e.target.value;
    data[name] = value;

    setAvailabilityDetail(data);
    callAvailabilityUpdateApi(availabilityDetail?.id, data, true);
    onEditTitle(false);
  };

  const callApi = async () => {
    await dispatch(get_calendar_availability_lists_action());
  };

  const callAvailabilityApi = async (id) => {
    await dispatch(get_calendar_availability_details_action(id));
  };

  const callAvailabilityUpdateApi = async (
    id,
    availabilities,
    updateList,
    dayName
  ) => {
    let newData = convertTimeFormat(availabilities, dayName);
    await dispatch(update_calendar_availability_action(id, newData));
    if (updateList) {
      callAvailabilityApi(id);
    }
  };
  //adding new interval
  const onIntervalAdd = (dayName) => {
    let data = availabilityDetail;

    //get time_intervals of a specific day
    let tArray =
      data?.local_time && data.local_time[dayName]
        ? data?.local_time && data.local_time[dayName]
        : [];
    let checkInterval = { check: true };

    // check if the interval exists
    if (tArray) {
      // get the times of the last element of time_interval array
      let tIndex = tArray.length === 0 ? null : tArray.length - 1;

      // if array does not contain any element
      //push default start and end time in time_interval array
      if (tIndex === null) {
        data.local_time[dayName] = [];
        data?.local_time &&
          data.local_time[dayName].push({
            start_time: "09:00:00",
            end_time: "17:00:00",
          });
      }
      //if array containe some elements
      else {
        //get the time interval, end times and split the end time in hours and minutes of last index
        let arr = tArray[tIndex];
        let endTime = arr.end_time;
        let endTimeSplit = endTime.split(":");

        //if the end time is greater than 22:30 then, can not add an interval
        if (endTime > "22:30:00") {
          checkInterval.check = false;
        }
        //if end time is 22:30 then, add 23:00 and 23:30 in time_interval array
        else if (endTime === "22:30:00") {
          data?.local_time &&
            data.local_time[dayName].push({
              start_time: "23:00:00",
              end_time: "23:30:00",
            });
        }
        //add 1 hour interval to the last item of the time_interval array
        else {
          let addedStartTime = `${(
            parseInt(endTimeSplit[0]) + 1
          ).toLocaleString("en-US", {
            minimumIntegerDigits: 2,
            useGrouping: false,
          })}:${endTimeSplit[1]}:00`;
          let addedEndTime = `${(parseInt(endTimeSplit[0]) + 2).toLocaleString(
            "en-US",
            { minimumIntegerDigits: 2, useGrouping: false }
          )}:${endTimeSplit[1]}:00`;

          data?.local_time &&
            data.local_time[dayName].push({
              start_time: addedStartTime,
              end_time: addedEndTime,
            });
        }
      }

      let dayCheck =
        Array.isArray(data?.days) &&
        data?.days.filter((item) => item?.day === dayName);

      if (!dayCheck.length) {
        data.days.push({ day: dayName });
      }

      if (checkInterval.check) {
        callAvailabilityUpdateApi(data?.id, data);
      }
    }
  };

  const convertTimeFormat = (timeData) => {
    const result = [];

    for (const [day, times] of Object.entries(timeData?.local_time)) {
      const dayObject = {
        day: day,
        time: times,
      };
      result.push(dayObject);
    }

    const updatedDays = { days: result };

    return updatedDays;
  };

  //when interval is changed
  const onIntervalChange = (value, key, dIndex, tIndex) => {
    let data = availabilityDetail;

    //get time_intervals of a specific day
    let tArray =
      data?.local_time && data.local_time[dIndex]
        ? data?.local_time && data.local_time[dIndex]
        : [];

    let checkInterval = { check: true };

    // check if the interval exists
    if (tArray) {
      //get start and end time of a specific interval
      let arr = tArray[tIndex];
      let startTime = arr.start_time;
      let endTime = arr.end_time;

      //for value selected of start_time
      if (key === "start_time") {
        //check if selected value is greater than end_time
        if (value >= endTime) {
          checkInterval.check = false;
          showWarningMessage("Start time can't be ahead end time");
        }
      }
      //for value selected of end_time
      else if (key === "end_time") {
        //check if selected value is less that start_time
        if (value <= startTime) {
          checkInterval.check = false;
          showWarningMessage("End time can't be behind start time");
        }
      }

      //if the selected time interval index is not the zeroth item
      if (tIndex > 0) {
        //get time_interval just before the selected interval
        let arrPrevInterval = tArray[tIndex - 1];

        //check if the selected interval time start or end time is
        if (value <= arrPrevInterval.end_time) {
          checkInterval.check = false;
          showWarningMessage("Time is already selected");
        }
      }

      //if all checks are passed call availability api
      if (checkInterval.check) {
        data.local_time[dIndex][tIndex][key] = value;
        // window.location.reload();
        setShowStartIntervalDropdown(false);
        setShowEndIntervalDropdown(false);
        callAvailabilityUpdateApi(data?.id, data);
      }
    }
  };

  const onIntervalDelete = (dIndex, tIndex) => {
    let data = availabilityDetail;
    //get time_intervals of a specific day
    let tArrayTime =
      data?.local_time && data.local_time[dIndex]
        ? data?.local_time && data.local_time[dIndex]
        : [];
    // check if the interval exists
    if (tArrayTime) {
      tArrayTime.splice(tIndex, 1);
      data.local_time[dIndex] = tArrayTime;
      callAvailabilityUpdateApi(data?.id, data, false, dIndex);
    }
  };

  const onAvailabilityChange = (id) => {
    setEditTitleActive(false);
    callAvailabilityApi(id);
  };
  const onAvailabilityDelete = async (id) => {
    setIsDeleteLoading(true);
    await dispatch(delete_calendar_availability_action(id));
    setIsDeleteLoading(false);
    dummyClickRef.current.click();
    callApi();
  };

  const onNewScheduleClick = async () => {
    if (createAvailabilityTitle === "") {
      showWarningMessage("Please enter schedule title");
    } else {
      let data = defaultAvailability;

      data.title = createAvailabilityTitle;
      setIsCreateAvailabilityLoading(true);
      const res = await dispatch(create_calendar_availability_action(data));
      setIsCreateAvailabilityLoading(false);

      if (res?.data) {
        handleClose();
      }
      callApi();
    }
  };

  const onCreateAvailabilityTitle = (e) => {
    const value = e.target.value;
    setCreateAvailabilityTitle(value);
  };

  const onPanelChange = (value, mode) => {};
  const onTimeZoneCick = async () => {
    if (user?.role === "mentor")
      navigate("/edit-mentor-profile", {
        state: {
          activeTab: "PersonalInformation",
        },
      });
    else if (user?.role === "hiring_manager")
      navigate("/hiring-manager-profile");
  };
  return {
    show,
    user,
    handleClose,
    availabilityList,
    availabilityDetail,
    editTitleActive,
    timeIntervals,
    dummyClickRef,
    onPanelChange,
    isCreateAvailabilityLoading,
    isDeleteLoading,
    loading,

    onFormInputChange,
    onEditTitle,
    onAvailabilityDelete,
    onIntervalAdd,
    onAvailabilityChange,
    onIntervalChange,
    onNewScheduleClick,
    onIntervalDelete,
    handleShow,
    onCreateAvailabilityTitle,
    onTimeZoneCick,
  };
}
export default useAvailability;












